import React from 'react';
import DemoFrame from './DemoFrame';
import useDemoPlayer, { typingDuration, useTypedText } from './useDemoPlayer';
import { DEMO_WORKSHEET } from './demoFixtures';

const W = DEMO_WORKSHEET;

// 0 요청 입력 → 1 만드는 중 → 2 학습지 → 3(완성) 한글로 저장하기
const STEPS = [typingDuration(W.prompt, 2, 30), 1300, 900];

const WorksheetResultDemo = ({ surface = 'home', title = 'AI 학습지', autoStart = false }) => {
  const player = useDemoPlayer({ steps: STEPS, surface, feature: 'worksheet', autoStart });
  const { phase, done, paused } = player;
  const prompt = useTypedText(W.prompt, { active: phase === 0, complete: phase > 0, paused, charsPerTick: 2, tickMs: 30 });

  return (
    <DemoFrame title={title} player={player}>
      <div className="wqdemo-chat">
        <div className="wqdemo-bubble-user">
          {prompt}
          {phase === 0 && <span className="wqdemo-cursor" style={{ background: '#ffffff' }} />}
        </div>
        {phase >= 1 && (
          <div className="wqdemo-image-card wqdemo-in">
            {phase === 1 ? (
              <div className="wqdemo-image-wait">
                <div className="wqdemo-skeleton" style={{ width: '100%', height: '100%' }} />
                <span>만드는 중…</span>
              </div>
            ) : (
              <img src={W.src} alt={W.alt} className="wqdemo-image is-paper" loading="lazy" />
            )}
            {done && (
              <div className="wqdemo-image-toolbar is-between wqdemo-in">
                <span className="wqdemo-ws-note">정답지 포함</span>
                <span className="wqdemo-btn is-primary">한글로 저장하기</span>
              </div>
            )}
          </div>
        )}
      </div>
    </DemoFrame>
  );
};

export default WorksheetResultDemo;
